import React from 'react';

import Heading from '@tds/core-heading';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import Paragraph from '@tds/core-paragraph';
import Strong from '@tds/core-strong';

import { ContentWrapper } from '../design/css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Expired = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contractSignature: {
      expiredPage: { header, message }
    }
  } = localizedStrings;

  return (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper>
          <Box between={3}>
            <Heading level="h2">{header}</Heading>
          </Box>
          <Paragraph>
            <Strong>{message}</Strong>
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Expired;
